import { TranslateDB } from '@app-i18n';

export type TranslateDBType = typeof TranslateDB;
export type TranslateLang = keyof TranslateDBType;

export const DEFAULT_LANG: TranslateLang = 'en';

export const currentLangs: TranslateLang[] = Object.keys(TranslateDB) as TranslateLang[];

export const AVAILABLE_LANGS: TranslateLang[] = Array.from(
  new Set<TranslateLang>([
    DEFAULT_LANG,
    ...currentLangs,
  ]),
);
